export const SEO_PAGES_DATA = {
  "manqanis-gakiraveba-taxisistvis": {
    path: "/manqanis-gakiraveba-taxisistvis",
    seoTitle: "მანქანის ქირაობა ტაქსისთვის თბილისში — Prius და Tesla 50 ₾-დან | taxipark.ge",
    seoDescription: "ტაქსის მანქანის ქირაობა თბილისში: Toyota Prius 50–85 ₾/დღე, Tesla Model 3 და Model Y, BYD Qin Plus. სრული დაზღვევა, A-კატეგორიის ლიცენზია, ტექნიკური მომსახურება და უფასო კვირა დღეები ფასში.",
    h1: "მანქანის ქირაობა ტაქსისთვის თბილისში",
    intro: "taxipark.ge არის ტაქსოპარკი თბილისში, სადაც ტაქსის მძღოლები იღებენ სამუშაოდ მზა ავტომობილებს ყოველდღიური ქირით — ლიცენზიით, დაზღვევითა და სრული ტექნიკური მხარდაჭერით. შენ მუშაობ, დანარჩენს ჩვენ ვზრუნავთ.",
    sections: [
      {
        h2: "როგორ მუშაობს ტაქსის მანქანის გაქირავება",
        text: "ირჩევ ავტომობილს ჩვენი ავტოპარკიდან, ტოვებ განაცხადს ან რეკავ — ხელშეკრულება ფორმდება ერთ სტუმრობაში. მანქანას იღებ სრულად მომზადებულს: გავლილი ტექნიკური ინსპექტირებით, დამონტაჟებული LPG სისტემით (ჰიბრიდებზე) და ტაქსის მუშაობისთვის საჭირო ყველა დოკუმენტით.",
      },
      {
        h2: "რა შედის დღიურ ფასში",
        list: [
          "სრული სადაზღვევო პაკეტი — შენი პასუხისმგებლობა მხოლოდ დეპოზიტის ფარგლებშია",
          "A-კატეგორიის ტაქსის ლიცენზია ყველა ავტომობილზე",
          "ტექნიკური მომსახურება და დახმარება 24/7",
          "უფასო კვირა დღეები ყოველ კვირაში",
          "Bus Lane-ში მუშაობის უფლება ჰიბრიდ და ელექტრო ავტომობილებზე",
        ],
      },
      {
        h2: "აირჩიე ავტომობილი შენი ბიუჯეტით",
        text: "ავტოპარკში გვყავს ეკონომიური Toyota Prius მოდელები 50 ₾-დან დღიურად და პრემიუმ ელექტრო ავტომობილები — Tesla Model 3, Tesla Model Y და BYD Qin Plus — Comfort და Comfort+ ტარიფებზე მუშაობისთვის. ყველა მანქანა ინდივიდუალური ჩანაწერითაა ნაჩვენები ზუსტი გამოშვების წლით, ფასითა და ხელმისაწვდომობით.",
        categories: ["prius-2013-2014", "prius-2016-2018", "prius-2019-2022", "tesla-model-3-2022-2023", "tesla-model-y-2022-2024", "byd-2026"],
      },
      {
        h2: "ვისთვისაა ეს სერვისი",
        text: "გაქირავება განკუთვნილია ტაქსის მძღოლებისთვის, რომლებსაც სურთ სტაბილური შემოსავალი საკუთარი ავტომობილის შეძენისა და მოვლის ხარჯების გარეშე. საკმარისია 26 წლის ასაკი, მინიმუმ 2 წლიანი მართვის გამოცდილება და მოქმედი დოკუმენტები.",
      },
    ],
    related: ["prius-gakiraveba", "tesla-gakiraveba", "tavisufali-manqanebi"],
  },
  "prius-gakiraveba": {
    path: "/prius-gakiraveba",
    seoTitle: "Toyota Prius ქირაობა ტაქსისთვის თბილისში — 50–85 ₾ დღიურად | taxipark.ge",
    seoDescription: "Prius ქირაობა ტაქსზე თბილისში: Toyota Prius 2013–2022 წლების მოდელები LPG სისტემით, 50–85 ₾ დღიურად. ყველაზე ეკონომიური არჩევანი ტაქსის მძღოლისთვის — Bus Lane, სრული დაზღვევა, უფასო კვირები.",
    h1: "Toyota Prius ქირაობა ტაქსისთვის",
    intro: "Toyota Prius ჩვენი ავტოპარკის გულია — ყველაზე ეკონომიური და გამძლე ავტომობილი ტაქსის ყოველდღიური მუშაობისთვის. სამივე თაობა გვყავს: 2013–2014, 2016–2018 და 2019–2022 წლების მოდელები.",
    sections: [
      {
        h2: "რატომ არის Prius ტაქსისთვის საუკეთესო არჩევანი",
        list: [
          "ჰიბრიდური ძრავი + LPG სისტემა — მინიმალური საწვავის ხარჯი ქალაქში",
          "Bus Lane-ში მოძრაობის უფლება — ნაკლები დრო პიკის საათებში",
          "დადასტურებული გამძლეობა ტაქსის ინტენსიურ რეჟიმში",
          "დაბალი დეპოზიტი — 150–200 ₾ კატეგორიის მიხედვით",
        ],
      },
      {
        h2: "Prius კატეგორიები და ფასები",
        text: "2013–2014 წლების Prius იწყება 50 ₾-დან დღიურად — იდეალური დასაწყისისთვის. 2016–2018 წლების მეოთხე თაობა 70–75 ₾ ღირს, ხოლო უახლესი 2019–2022 წლების მოდელები — 80–85 ₾. ყველა კატეგორიაში ხედავ თითოეულ რეალურ ავტომობილს ზუსტი წლითა და ფოტოებით.",
        categories: ["prius-2013-2014", "prius-2016-2018", "prius-2019-2022"],
      },
      {
        h2: "ქირის პირობები",
        text: "ყოველდღიური ქირა მოიცავს სრულ დაზღვევას, A-კატეგორიის ლიცენზიას, ტექნიკურ მომსახურებას და უფასო კვირა დღეებს. ხელშეკრულება ფორმდება სწრაფად — საკმარისია პირადობა, მართვის მოწმობა, 26 წლის ასაკი და 2 წლიანი მართვის გამოცდილება.",
      },
    ],
    related: ["manqanis-gakiraveba-taxisistvis", "tesla-gakiraveba", "tavisufali-manqanebi"],
  },
  "tesla-gakiraveba": {
    path: "/tesla-gakiraveba",
    seoTitle: "Tesla ქირაობა ტაქსისთვის თბილისში — Model 3 და Model Y | taxipark.ge",
    seoDescription: "Tesla ქირაობა ტაქსისთვის: Tesla Model 3 2022–2023 და Tesla Model Y 2022–2024 ელექტრო ავტომობილები Comfort, Comfort+ და Electric ტარიფებისთვის. Bus Lane, სრული დაზღვევა, 100–150 ₾ დღიურად.",
    h1: "Tesla ქირაობა ტაქსისთვის",
    intro: "Tesla Model 3 და Model Y ტაქსის მძღოლებს უშლის უფრო მაღალ ტარიფებზე მუშაობის საშუალებას — Comfort, Comfort+ და Electric კატეგორიები უფრო მეტ შემოსავალს ნიშნავს იგივე სამუშაო საათებში.",
    sections: [
      {
        h2: "რატომ Tesla ტაქსისთვის",
        list: [
          "Comfort, Comfort+ და Electric ტარიფებზე მუშაობის უფლება",
          "ელექტროენერგია მკვეთრად იაფია საწვავზე — მეტი რჩება შენ",
          "Bus Lane-ში მოძრაობის უფლება",
          "თანამედროვე იმიჯი — მგზავრები ხშირად უწერენ კარგ შეფასებებს",
        ],
      },
      {
        h2: "Tesla Model 3 და Model Y ჩვენს ავტოპარკში",
        text: "Tesla Model 3 (2022–2023) ელექტრო სედანია 100 ₾ დღიური ფასით — ყველაზე პოპულარული არჩევანი Electric ტარიფისთვის. Tesla Model Y (2022–2024) კროსოვერი 150 ₾-დან განკუთვნილია მათთვის, ვისაც მეტი სივრცე და პრემიუმ კლასის მგზავრები სურს. ორივე მოდელზე დეპოზიტი 400 ₾-ია.",
        categories: ["tesla-model-3-2022-2023", "tesla-model-y-2022-2024"],
      },
      {
        h2: "დატენვა და ყოველდღიური მუშაობა",
        text: "თბილისში სწრაფი დამტენების ქსელი ყოველდღიურ მუშაობას მარტივად ხდის შესაძლებელს — ღამით სახლში ან დღის განმავლობაში სწრაფ დამტენებზე. ჩვენი გუნდი დაგეხმარება დატენვის რეჟიმის დაგეგმვაშიც.",
      },
    ],
    related: ["manqanis-gakiraveba-taxisistvis", "elektro-manqanebi-taxisistvis", "tavisufali-manqanebi"],
  },
  "elektro-manqanebi-taxisistvis": {
    path: "/elektro-manqanebi-taxisistvis",
    seoTitle: "ელექტრო მანქანები ტაქსისთვის თბილისში — Tesla და BYD ქირით | taxipark.ge",
    seoDescription: "ელექტრო ავტომობილების ქირაობა ტაქსისთვის: Tesla Model 3, Tesla Model Y და BYD Qin Plus 2026. ნულოვანი საწვავის ხარჯი, Bus Lane უფლება, Electric ტარიფები — 100 ₾-დან დღიურად.",
    h1: "ელექტრო მანქანები ტაქსისთვის",
    intro: "ელექტრო ავტომობილი ტაქსისთვის ნიშნავს ნულოვან საწვავის ხარჯს და უფლებას იმუშაო Electric და Comfort+ ტარიფებზე. ჩვენს ავტოპარკში სამი ელექტრო მოდელია: Tesla Model 3, Tesla Model Y და BYD Qin Plus.",
    sections: [
      {
        h2: "ელექტრო ავტომობილის უპირატესობები ტაქსიში",
        list: [
          "დღიური საწვავის ხარჯი რამდენიმე ლარია ბენზინის ნაცვლად",
          "Electric და Comfort+ ტარიფები — მეტი შემოსავალი თითო კურსზე",
          "Bus Lane-ში მოძრაობა და ნაკლები ტექნიკური ხარჯები",
          "ჩუხი, კომფორტული სალონი — მგზავრები აფასებენ",
        ],
      },
      {
        h2: "ელექტრო მოდელები ჩვენს ავტოპარკში",
        text: "Tesla Model 3 — 100 ₾/დღე, ყველაზე დაბალანსებული არჩევანი Electric ტარიფისთვის. Tesla Model Y — 150 ₾/დღე, პრემიუმ კროსოვერი მეტი სივრცით. BYD Qin Plus 2026 — ახალი თაობის ელექტრო სედანი 100 ₾-დან 300 ₾ დეპოზიტით, რაც Tesla-ზე დაბალი შესასვლელი ზღვარია.",
        categories: ["tesla-model-3-2022-2023", "tesla-model-y-2022-2024", "byd-2026"],
      },
      {
        h2: "ვის უნდება ელექტრო ტაქსში",
        text: "თუ ძირითადად ცენტრში და Bus Lane-ების მიმართულებით მუშაობ, ელექტრო მანქანა შენს შემოსავალს საგრძნობლად ზრდის. ჰიბრიდი Prius კი რჩება საუკეთესო უნივერსალურ ვარიანტად ნებისმიერი რეჟიმისთვის.",
      },
    ],
    related: ["tesla-gakiraveba", "prius-gakiraveba", "tavisufali-manqanebi"],
  },
  "tavisufali-manqanebi": {
    path: "/tavisufali-manqanebi",
    seoTitle: "თავისუფალი ტაქსის ავტომობილები ახლა — ხელმისაწვდომობა რეალურ დროში | taxipark.ge",
    seoDescription: "იხილე ამ წუთას თავისუფალი ტაქსის ავტომობილები taxipark.ge-ზე: Toyota Prius, Tesla Model 3/Y და BYD Qin Plus რეალური ფოტოებით, ზუსტი ფასებითა და ხელმისაწვდომობის სტატუსებით.",
    h1: "ახლა თავისუფალი ავტომობილები",
    intro: "ქვემოთ ჩამოთვლილია ყველა ავტომობილი, რომელიც ამ წუთას თავისუფალია და მზადაა სამუშაოდ. სია ავტომატურად ახლდება — თუ მანქანა გაქირავდა ან დაჯავშნილია, ის აქ აღარ გამოჩნდება.",
    live: true,
    sections: [
      {
        h2: "როგორ დაჯავშნო თავისუფალი მანქანა",
        text: "აირჩიე ავტომობილი სიიდან, გახსენი მისი გვერდი და დააჭირე ღილაკს „დაჯავშნა“ — მივიღებთ შენს განაცხადს და დაგიკავშირდებით დაზუსტებისთვის. ან უბრალოდ დაგვირეკე ნომერზე 591 063 123.",
      },
      {
        h2: "თუ სასურველი მანქანა დაკავებულია",
        text: "დაქირავებულ ავტომობილზე შეგიძლია მოითხოვო შეტყობინება — როგორც კი გათავისუფლდება, შეგატყობინებთ. ასე რომ ნუ დაიკარგები, თუ დღეს სასურველი მოდელი დაკავებულია.",
      },
    ],
    related: ["manqanis-gakiraveba-taxisistvis", "prius-gakiraveba", "tesla-gakiraveba"],
  },
};

export const SEO_PAGE_LINKS = [
  { path: "/manqanis-gakiraveba-taxisistvis", label: "მანქანის ქირაობა ტაქსისთვის" },
  { path: "/prius-gakiraveba", label: "Prius ქირაობა ტაქსზე" },
  { path: "/tesla-gakiraveba", label: "Tesla ქირაობა ტაქსისთვის" },
  { path: "/elektro-manqanebi-taxisistvis", label: "ელექტრო მანქანები ტაქსისთვის" },
  { path: "/tavisufali-manqanebi", label: "თავისუფალი ავტომობილები" },
];
